import { render } from "./NotificationPreferences.vue?vue&type=template&id=36ae6e97&scoped=true"
import script from "./NotificationPreferences.vue?vue&type=script&lang=js"
export * from "./NotificationPreferences.vue?vue&type=script&lang=js"

import "./NotificationPreferences.vue?vue&type=style&index=0&id=36ae6e97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ae6e97"]])

export default __exports__